import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '../ui/dialog';
import { Button } from '../ui/button';
import { AlertCircle } from 'lucide-react';
import type { MonitoredSite } from '../../types';

interface DeleteSiteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  site: MonitoredSite | null;
  onConfirm: (id: string) => Promise<void>;
}

export function DeleteSiteDialog({ open, onOpenChange, site, onConfirm }: DeleteSiteDialogProps) {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleConfirm = async () => {
    if (!site) return;

    try {
      setIsDeleting(true);
      await onConfirm(site.id);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertCircle className="h-5 w-5 text-red-600" />
            Confirmar Exclusão
          </DialogTitle>
          <DialogDescription>
            Esta ação não pode ser desfeita. O site será removido permanentemente do monitoramento.
          </DialogDescription>
        </DialogHeader>

        {site && (
          <div className="bg-muted rounded-lg p-4 space-y-2">
            <p className="text-sm">
              <span className="font-medium">Nome:</span> {site.name}
            </p>
            <p className="text-sm">
              <span className="font-medium">URL:</span> {site.url}
            </p>
          </div>
        )}

        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isDeleting}
          >
            Cancelar
          </Button>
          <Button
            type="button"
            variant="destructive"
            onClick={handleConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? 'Excluindo...' : 'Excluir Site'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
